import RequiredAgreements from 'views/application/requiredAgreements/RequiredAgreements';

export default {
	'components.RequiredAgreements.Template': {
		factory: RequiredAgreements,
		deps: [{ $ref: 'components.Agreements' }, { $ref: 'services.applicationService' }],
	},
};
